<template>
    <div id="navigation">
        <div class="row p-3">
            <div class="col-12">
                <div class="hvr-outline-out hvr-grow-xs float-right cursor-pointer d-flex justify-content-center align-items-center" @click="hideNavigation()">
                    <i class="fas fa-times"></i>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-5 col-lg-4 col-12"></div>

            <div class="col-xl-7 col-lg-8 col-12 px-xl-0 px-4" id="menu">
                <ul class="d-inline-block">
                    <li v-for="(item, index) in $root.menuitems" :id="'menuitem-' + index" @click="changeRoute(item.name)">
                        <div class="line-menuitem d-inline-block"></div>
                        <h1 class="labgrotesque-bold d-inline-block mb-0">
                            {{ $t(item.meta.title) }}
                        </h1>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'navigation',

    mounted() {
        this.$root.animejs({
            targets: 'footer #footer-contacts, footer .footer-biswiss',
            opacity: 0,
            easing: "easeOutExpo",
            duration: 500
        });
        this.$root.animejs({
            targets: 'footer #footer-black',
            height: '35px',
            easing: "easeInOutQuad",
            duration: 500
        });
        this.$root.animejs({
            targets: 'footer #footer-builtoverinnovation',
            opacity: [0, 1],
            easing: "easeInOutQuad",
            duration: 500
        });

        var animation = this.$root.animejs.timeline({loop: false});
        $.each(this.$root.menuitems, function(index, value) {
            animation.add({
                targets: '#menuitem-' + index,
                opacity: [0,1],
                easing: "easeInOutQuad",
                duration: 100
            });
        });
    },

    methods: {
        hideNavigation() {
            var thisObj = this;

            var animation = this.$root.animejs.timeline({loop: false});
            for(var i = this.$root.menuitems.length - 1; i >= 0; i--) {
                animation.add({
                    targets: '#menuitem-' + i,
                    opacity: 0,
                    easing: "easeInOutQuad",
                    duration: 100
                });
            }

            animation.add({
                begin: function(anim) {
                    thisObj.$emit("hideNavigation");
                }
            });
        },

        changeRoute(newRoute) {
            var thisObj = this;

            var animation = this.$root.animejs.timeline({loop: false});
            for(var i = this.$root.menuitems.length - 1; i >= 0; i--) {
                animation.add({
                    targets: '#menuitem-' + i,
                    opacity: 0,
                    easing: "easeInOutQuad",
                    duration: 100
                });
            }

            animation.add({
                begin: function(anim) {
                    if(newRoute !== "numeri") {
                        thisObj.$emit("hideNavigation");
                    }

                    if(thisObj.$route.name != newRoute) {
                        thisObj.$root.resetTransitionRouterView();
                        thisObj.$router.push({name: newRoute});
                        thisObj.$root.changeRouteView();

                        if(newRoute === "numeri") {
                            $("footer #footer-builtoverinnovation").css("opacity", 0);
                            $("#navigation").css("opacity", 0);
                            $("#content, footer #footer-contacts, footer .footer-biswiss").css("opacity", 1);
                            $("footer #footer-black").css("height", "70px");
                            thisObj.$parent.showMenu = false;
                        }
                    }
                    else if(thisObj.$route.name === "servizi" && newRoute === "servizi") {
                        thisObj.$emit("refreshServices");
                    }
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation.vue